import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export default function Step2PatientInfo({ formData, updateFormData, errors }) {
  const handleChange = (field, value) => {
    updateFormData({
      ...formData,
      patient_info: {
        ...formData.patient_info,
        [field]: value,
      },
    });
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-heading font-bold text-slate-900 mb-2">
          Datos del Paciente
        </h2>
        <p className="text-slate-600">
          Información del animal a examinar
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="patient-nombre" className="font-medium text-slate-700">
            Nombre del paciente <span className="text-red-500">*</span>
          </Label>
          <Input
            id="patient-nombre"
            data-testid="patient-nombre-input"
            placeholder="Max"
            value={formData.patient_info.nombre}
            onChange={(e) => handleChange('nombre', e.target.value)}
            className={`h-11 ${errors.patient_nombre ? 'border-red-500' : ''}`}
          />
          {errors.patient_nombre && (
            <p className="text-sm text-red-500">{errors.patient_nombre}</p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="patient-especie" className="font-medium text-slate-700">
            Especie <span className="text-red-500">*</span>
          </Label>
          <Select
            value={formData.patient_info.especie}
            onValueChange={(value) => handleChange('especie', value)}
          >
            <SelectTrigger
              data-testid="patient-especie-select"
              className={`h-11 ${errors.patient_especie ? 'border-red-500' : ''}`}
            >
              <SelectValue placeholder="Seleccionar especie" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="Canino">Canino</SelectItem>
              <SelectItem value="Felino">Felino</SelectItem>
              <SelectItem value="Equino">Equino</SelectItem>
              <SelectItem value="Bovino">Bovino</SelectItem>
              <SelectItem value="Porcino">Porcino</SelectItem>
              <SelectItem value="Ovino">Ovino</SelectItem>
              <SelectItem value="Caprino">Caprino</SelectItem>
              <SelectItem value="Avícola">Avícola</SelectItem>
              <SelectItem value="Otro">Otro</SelectItem>
            </SelectContent>
          </Select>
          {errors.patient_especie && (
            <p className="text-sm text-red-500">{errors.patient_especie}</p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="patient-raza" className="font-medium text-slate-700">
            Raza <span className="text-red-500">*</span>
          </Label>
          <Input
            id="patient-raza"
            data-testid="patient-raza-input"
            placeholder="Pastor Alemán"
            value={formData.patient_info.raza}
            onChange={(e) => handleChange('raza', e.target.value)}
            className={`h-11 ${errors.patient_raza ? 'border-red-500' : ''}`}
          />
          {errors.patient_raza && (
            <p className="text-sm text-red-500">{errors.patient_raza}</p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="patient-edad" className="font-medium text-slate-700">
            Edad <span className="text-red-500">*</span>
          </Label>
          <Input
            id="patient-edad"
            data-testid="patient-edad-input"
            placeholder="5 años"
            value={formData.patient_info.edad}
            onChange={(e) => handleChange('edad', e.target.value)}
            className={`h-11 ${errors.patient_edad ? 'border-red-500' : ''}`}
          />
          {errors.patient_edad && (
            <p className="text-sm text-red-500">{errors.patient_edad}</p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="patient-sexo" className="font-medium text-slate-700">
            Sexo <span className="text-red-500">*</span>
          </Label>
          <Select
            value={formData.patient_info.sexo}
            onValueChange={(value) => handleChange('sexo', value)}
          >
            <SelectTrigger
              data-testid="patient-sexo-select"
              className={`h-11 ${errors.patient_sexo ? 'border-red-500' : ''}`}
            >
              <SelectValue placeholder="Seleccionar sexo" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="Macho">Macho</SelectItem>
              <SelectItem value="Hembra">Hembra</SelectItem>
            </SelectContent>
          </Select>
          {errors.patient_sexo && (
            <p className="text-sm text-red-500">{errors.patient_sexo}</p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="patient-propietario" className="font-medium text-slate-700">
            Propietario <span className="text-red-500">*</span>
          </Label>
          <Input
            id="patient-propietario"
            data-testid="patient-propietario-input"
            placeholder="María González"
            value={formData.patient_info.propietario}
            onChange={(e) => handleChange('propietario', e.target.value)}
            className={`h-11 ${errors.patient_propietario ? 'border-red-500' : ''}`}
          />
          {errors.patient_propietario && (
            <p className="text-sm text-red-500">{errors.patient_propietario}</p>
          )}
        </div>
      </div>
    </div>
  );
}